{
    "ChangeMenuTitle": "Change Report",
    "UnknownReport": "[Unknown Report]",
    "NoSuitableReportsAvailable": "No Suitable Reports Available.",
    "DashboardChangeFolderEmpty": "All of the reports in this folder have already been used in this dashboard...",
    "NAME": "DashboardList",
    "DashboardList_SectionHeader": "List",
    "DashboardList_Add": "Add",
    "DashboardList_AddMenuTitle": "Add & Remove",
    "DashboardList_MoveUp": "Move up",
    "DashboardList_MoveDown": "Move down",
    "DashboardList_Remove": "Remove",
    "DashboardList_RemoveAll": "Remove all",
    "DashboardList_RemoveAllConfirmMessage": "Are you sure you wish to remove all reports?"
}